import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { AddCreditFormSchema, CREDIT_PRICE_TYPES, type AddCreditForm } from './add-credit-form-schema';
import { CREDIT_KINDS, CREDIT_EXPIRATION_POLICIES, CREDIT_SCHEDULES } from '@vy/types';

export function useAddCreditForm(initial?: Partial<AddCreditForm>) {
  return useForm<AddCreditForm>({
    resolver: zodResolver(AddCreditFormSchema),
    mode: 'onChange',
    defaultValues: {
      name: '',
      creditTypeId: '',
      creditKind: CREDIT_KINDS.MONETARY,
      priceType: CREDIT_PRICE_TYPES.OneTime,
      schedule: CREDIT_SCHEDULES.RECURRING_MONTHLY,
      amount: undefined,
      expiryDate: undefined,
      expirationPolicy: CREDIT_EXPIRATION_POLICIES.NEVER,
      applyAutomatically: true,
      ...initial,
    },
  });
}
